export const PAYMENT_TYPES = {
    IDLE: 'idle',
    ONLINE_TRANSACTION: 'online_transaction',
    ONLINE: 'online',
    CASH: 'cash',
    YANDEX_DELIVERY: 'yandex_delivery',
    ONLINE_CHANGE: 'online-change',
    SBP_COURIER: 'sbp_courier',
    INVOICE_BOX: '7', // инвойс-бокс
    PAYMENT_UNDER_CONTRACT: '4', // оплата по договору
    GIFT_CARD: 'gift_card', // сертификат
    CARD_COURIER: 'card_courier',
    PREORDER: 'preorder',
    STAFF: 'staff',
}
